// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","contained":"Button_contained__ueupA","text":"Button_text__Rk+Tr","outlined":"Button_outlined__-tAZi"};